import { PlusIcon } from '../../constants/globalStyles.Styles';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { BioScopeCreators } from './store/action';
import Pagination from '../../components/Pagination/Pagination.View';
import {
  Page,
  Container,
  HeaderContainer,
  HeaderLeftContainer,
  HeaderTitleContainer,
  HeaderTitle,
  HeaderRightContainer,
  AddBioScopeButtonContainer,
  AddBioScopeButton,
  BioScopeTableContainer,
  BioScopeTable,
  BioScopeThead,
  BioScopeTH,
  BioScopeTBoddy,
  BioScopeTR,
  BioScopeTD,
  BioScopeApprovedColumn,
  LoadingFiller,
} from './BioScope.Styles';
import { useNavigate } from 'react-router-dom';

const BioScope = () => {
  const bioSopeList = useSelector((state) => state.bioScope);
  const loadingBiosopeList = useSelector((state) => state.bioScope.loadingBioSopeList);
  const total_page = bioSopeList.bioScopeListTotalPage;
  const allbioScopes = bioSopeList.bioScopeList;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const [loadingBioscope, setLoadingBioscope] = useState(loadingBiosopeList);
  const [pageSize, setPageSize] = useState(10);

  const visitDetails = (e) => {
    navigate(`details/${e}`);
  };

  return (
    <Page>
      <Container>
        <HeaderContainer>
          <HeaderLeftContainer>
            <HeaderTitleContainer>
              <HeaderTitle>Bio Scope</HeaderTitle>
            </HeaderTitleContainer>
          </HeaderLeftContainer>
          <HeaderRightContainer>
            <AddBioScopeButtonContainer>
              <AddBioScopeButton to={'add'}>
                <PlusIcon />
                Add Bio Scope
              </AddBioScopeButton>
            </AddBioScopeButtonContainer>
          </HeaderRightContainer>
        </HeaderContainer>
        <BioScopeTableContainer>
          <BioScopeTable>
            <BioScopeThead>
              <BioScopeTR>
                <BioScopeTH>NAME</BioScopeTH>
                <BioScopeTH>ADDED DATE</BioScopeTH>
                <BioScopeTH>ADDED BY</BioScopeTH>
                <BioScopeTH>APPROVED/REJECTED BY</BioScopeTH>
                <BioScopeTH>APPROVAL STATUS</BioScopeTH>
              </BioScopeTR>
            </BioScopeThead>
            <BioScopeTBoddy>
              {loadingBiosopeList ? (
                <BioScopeTR>
                  <BioScopeTD>
                    <LoadingFiller>Fetching Data...</LoadingFiller>
                  </BioScopeTD>
                </BioScopeTR>
              ) : (
                allbioScopes.map((bioScope, id) => {
                  return (
                    <BioScopeTR key={id.toString()} onClick={() => visitDetails(bioScope.id)}>
                      <BioScopeTD>{bioScope.answer?.name}</BioScopeTD>
                      <BioScopeTD>{bioScope.date}</BioScopeTD>
                      <BioScopeTD> {bioScope.added_by} </BioScopeTD>
                      <BioScopeTD> {bioScope.rejected_by} </BioScopeTD>
                      <BioScopeTD>
                        <BioScopeApprovedColumn approve={bioScope.approved}>
                          {bioScope.approved === true
                            ? 'Approved'
                            : bioScope.approved_rejected_by === ''
                            ? 'Waiting for Approval'
                            : 'Rejected'}
                        </BioScopeApprovedColumn>
                      </BioScopeTD>
                    </BioScopeTR>
                  );
                })
              )}
            </BioScopeTBoddy>
          </BioScopeTable>
          <Pagination
            total_pages={total_page}
            pagesFor={'bioscopes'}
            page_size={pageSize}
          ></Pagination>
        </BioScopeTableContainer>
      </Container>
    </Page>
  );
};
export default BioScope;
